export const profileContent = `/*
  Author: Nguyen Thanh Sang (Shang)
  Description: My profile as a Front End Developer
  Homepage: https://shangdev.id.vn/
  Repository: https://github.com/sangthanh052/shangdev-portfolio/
*/
const my_profile: ProfileTypes = {
  Fullname: 'Nguyen Thanh Sang',
  Title: 'Front-End Developer',
  YOE: '5+',
  Skills: {
    Languages: ['JavaScript (ES6+)', 'TypeScript', 'Shopify (Liquid)', 'Salesforce (SFRA)'],
    Frontend: [
      'ReactJS', 'Redux/Toolkit', 'Context API', 'React Query',
      'Jquery', 'React Hook Form', 'Zod/Yup', 'Lodash', 'Immer'
    ],
    APIs_Networking: ['RESTful APIs', 'Axios', 'Fetch'],
    UI_Styling: [
      'Tailwind CSS', 'SCSS Modules', ' ShadcnUI', 'MagicUI', 'Framer Motion'
      'Chakra UI', 'Aceternity UI', 'Bootstrap 4+', 'Styled Components'
    ],
    Testing: ['Jest', 'Vitest', 'React Testing Library', 'MSW', 'Snapshot Testing'],
    Build_Tools: ['Vite', 'Webpack', 'Babel', 'Gulp', 'Postman'],
    CICD_Cloud: [
      'GitHub Actions', 'SFCC Cartridge build & deploy',
      'CDN/static assets', 'Cloudflare', 'Vercel', 'Netlify'
    ],
    VersionControl_Workflow: [
      'Git', 'GitHub', 'Bitbucket',
      'Agile/Scrum methodologies', 'Jira'
    ]
  },
  Others: [
    'Design Patterns', 'StoryBook', 'Mobile-First UI', 
    'Lazy loading', 'Code splitting', 'Tree-shaking', 'Memoization',
    'Accessibility compliance (WCAG, ADA)', 'axe DevTools', 'BrowserStack',
    'Atomic Design', 'Wireframe Design', 'Figma', 'Zeplin', 'Photoshop', 'Canva'
  ]
  
};`;
